import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthGuard } from '../../components/AuthGuard';
import ConfigLayout from './layouts/ConfigLayout';
import CommonConfigPage from './common-config/CommonConfigPage';
import WarehousePlanningEntryConfigPage from './entry-config/WarehousePlanningEntryConfigPage';
import DegradeManagementPage from './degrade/DegradeManagementPage';
import AppVersionPage from './app-version/AppVersionPage';
import PodCaptureConfigPage from './pod-capture-config/PodCaptureConfigPage';
import PodCaptureConfigV2Page from './pod-capture-config-v2/PodCaptureConfigV2Page';
import PdaScanConfigPage from './pda-scan-config/PdaScanConfigPage';

const ConfigRoutes: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<AuthGuard><ConfigLayout /></AuthGuard>}>
                <Route path="common-config" element={<CommonConfigPage />} />
                <Route path="pod-capture-config" element={<PodCaptureConfigPage />} />
                <Route path="pod-capture-config-v2" element={<PodCaptureConfigV2Page />} />
                <Route path="entry-config" element={<WarehousePlanningEntryConfigPage />} />
                <Route path="degrade" element={<DegradeManagementPage />} />
                <Route path="app-version" element={<AppVersionPage />} />
                <Route path="pda-scan-config" element={<PdaScanConfigPage />} />
            </Route>
        </Routes>
    );
};

export default ConfigRoutes;
